import { Domain } from '../../domains/domain';

export class Folder {
  public id?: string;
  public name: string;
  public domain?: Domain;
}
